
import { dynamicImportWithRetry } from "@fatso83/retry-dynamic-import"

import {
  onCLS,
  onLCP,
} from "web-vitals"
// Polyfill for FID
import "first-input-delay"

import log from "plugins/loglevel"

import "app/deferred_performance_entry_tracker/index"


declare global {
  interface Window {
    _spacious_main_css_loaded?: boolean
  }
}


function init() {
  onCLS(({value}) => {
    log.debug(`cumulative-layout-shift: ${value}`)

    window.spacious_post_tti_performance_entries.push({
      performance_entry_type:       "spacious-custom",
      performance_entry_name:       "cumulative-layout-shift",
      performance_entry_start_time: 0,
      performance_entry_duration:   value,

      spacious_page_html_id:        document.querySelector("html")?.id,
      spacious_main_css_loaded:     window._spacious_main_css_loaded === true,
    })
  })

  onLCP(({value}) => {
    log.debug(`largest-contentful-paint: ${value}`)

    window.spacious_post_tti_performance_entries.push({
      performance_entry_type:       "spacious-custom",
      performance_entry_name:       "largest-contentful-paint",
      performance_entry_start_time: 0,
      performance_entry_duration:   value,

      spacious_page_html_id:        document.querySelector("html")?.id,
      spacious_main_css_loaded:     window._spacious_main_css_loaded === true,
    })

    dynamicImportWithRetry(() => import(
      "app/deferred_task_executor/spacious_post_lcp_tasks"
    ))
    .then((module) => {
      // We don't use `requestIdleCallback` here since
      // It's after TTI already
      module?.runAllPostLCPTasks?.()
    })
  })
}

export default {
  init,
}
